<template>
    <div id="cancel-accept-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="cancel">Отменить</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="accept">Применить</div>
    </div>
</template>

<script>
    import {bus} from "../../../vue_bus";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "RightLowerBarEditPhotoConfirmation",
        computed: {
            idActivePhoto(){
                return this.$store.state.route.params.photoID;
            },
            photoPlanes() {
                return this.$store.getters["active/ALL_PLANES_FROM_PHOTO"]
            }
        },
        methods: {
            save() {
                return  () => {
                    bus.$emit("phe_save_changes")
                    this.$router.push({name: "viewPhoto", query: this.$store.state.route.query}).catch(err=>{});
                }
            },
            accept() {
                if (typeof this.idActivePhoto !== 'undefined') {
                    if (Object.keys(this.photoPlanes).length > 0) {
                        const title = 'Внимание!'
                        const text = 'Данный проект содержит плоскости на данной фотографии. При изменении фотографии эти плоскости будут утеряны! Вы уверены, что хотите продожить?';
                        this.$modal.show(ModalConfirmation, {title, text, alright: this.save()}, {
                            name: 'confirmationModal',
                            height: 'auto',
                            pivotY: 0.2,
                            width: 460,
                            draggable: true,
                        });
                    } else {
                        bus.$emit("phe_save_changes")
                        this.$router.push({name: "viewPhoto", query: this.$store.state.route.query}).catch(err=>{});
                    }
                }
            },
            cancel() {
                bus.$emit("phe_cancel_changes");
                this.$router.push({name: "viewPhoto"}).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
